<template>
  <div
    class="sidebar"
    :class="{ 'show-sidebar': showSidebar }"
    @click.self="showSidebar = !showSidebar"
  >
    <div class="sidebar__wrapper">
      <div class="sidebar__bars" @click="showSidebar = !showSidebar">
        <i class="icon-bars"></i>
      </div>

      <i class="icon-close" @click="showSidebar = !showSidebar"></i>

      <div class="sidebar__logo">
        <img :src="require('@/assets/img/valyoo-logo-blanco.svg')" alt="logo de valyoo" />
      </div>

      <router-link
        v-for="(item, index) in sidebarItems"
        :key="index"
        :to="{name: item.name}"
        custom
        v-slot="{href, navigate}"
      >
      <a
        class="sidebar__option"
        :class="{ selected: item.name == $route.name || item.name == $route.meta.parent }"
        v-show="item.meta.icon"
        :href="href"
        @click.stop="navigate"
      >
        <div>
          <SvgIcon
            :path="icons[item.meta.icon]"
            viewBox="0 0 24 24"
            :width="34"
            :height="34"
            :fill="
              item.name == $route.name || item.name == $route.meta.parent
                ? '#000000'
                : '#ffffff'
            "
          ></SvgIcon>
          <span>{{ item.name }}</span>
        </div>
      </a>
      
      </router-link>
    </div>
  </div>
</template>

<script>
import SvgIcon from "./helpers/SvgIcon.vue";
import {
  mdiDomain,
  mdiFileMultiple,
  mdiAccountGroup,
  mdiCalendarMonth,
  mdiChartBar,
  mdiCash,
  mdiAirplane,
  mdiAccountSupervisor,
  mdiHome,
  mdiCog,
  mdiText
} from "@mdi/js";
export default {
  components: {
    SvgIcon,
  },
  props: ["items"],
  created() {
    this.showSidebar = window.innerWidth < 900 ? false : true;
  },
  data: () => ({
    showSidebar: false,
    icons: {
      "icon-home": mdiHome,
      "icon-files": mdiFileMultiple,
      "icon-user": mdiAccountGroup,
      "icon-calendar": mdiCalendarMonth,
      "icon-counting": mdiChartBar,
      "icon-cts": mdiCash,
      "icon-plane": mdiAirplane,
      "icon-master": mdiAccountSupervisor,
      "icon-business": mdiDomain,
      "icon-setting": mdiCog,
      "icon-text": mdiText
    },
  }),
  methods: {
    routeTo(route) {
      this.$router.push({ name: route });

      if (window.innerWidth < 900)
        setTimeout(() => {
          this.showSidebar = !this.showSidebar;
        }, 500);
    },
  },
  computed: {
    sidebarItems() {
      if (!this.$store.state.login.currentUser) return [];
      if (this.$store.getters.isAdmin) {
        return this.items.filter((it) => Boolean(it.meta) && it.meta.icon);
      }
      if (this.$store.getters.roleIn.includes("owner")) {
        return this.items
          .filter((it) => Boolean(it.meta) && it.meta.icon)
          .filter((i) => i.path != "system-users" && i.path != "business");
      }
      if (this.$store.getters.roleIn.includes("guest")) {
        return this.items
          .filter((it) => Boolean(it.meta) && it.meta.icon)
          .filter(
            (i) =>
              i.path != "system-users" &&
              i.path != "business" &&
              i.path != "home" &&
              i.path != "business-users" &&
              i.path != "settings"
          );
      }
      return this.items
        .filter((it) => Boolean(it.meta) && it.meta.icon)
        .filter(
          (i) =>
            i.path != "system-users" &&
            i.path != "business" &&
            i.path != "home" &&
            i.path != "business-users"
        );
    },
  },
};
</script>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: "../assets/img/";

//2-VENDORS
.show-sidebar {
  left: 0 !important;
  background-color: rgba(#000, 0.7) !important;
}

.selected {
  background-color: $b-orange;
  border-left: 3px solid $b-orange !important;
  i {
    color: $b-orange !important;
  }
  svg {
    path {
      fill: #000000 !important;
    }
  }
}

//3-TOOLS
//functions
//background-image function
@function bimg($img) {
  @return url($p-img + $img);
}
//mixins
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}

.sidebar {
  position: fixed;
  top: 0;
  left: -100%;
  background-color: rgba(#000, 0);
  height: 100%;
  width: 100%;
  z-index: 100;
  transition: left 0.3s ease-out, background-color 0.3s ease-out 0.5s;
  @include mq($md) {
    width: 18rem;
  }

  &__wrapper {
    width: 75%;
    height: 100%;
    position: relative;
    background-color: $b-blue;
    overflow-y: auto;
    @include mq($md) {
      width: 100%;
    }
  }

  &__bars {
    position: fixed;
    top: 0;
    left: 0;
    height: 4rem;
    width: 4rem;
    border-left: 3px solid $b-orange;
    display: flex;
    justify-content: center;
    align-items: center;
    // background-color: #eceff8;
    z-index: -50;
    @include mq($md) {
      cursor: pointer;
    }

    .icon-bars {
      font-size: 2rem;
      line-height: 2rem;
      color: #a6abb7;
    }
  }

  .icon-close {
    position: absolute;
    top: 0.5rem;
    right: 1rem;
    font-size: 2rem;
    line-height: 2rem;
    color: #fff;
    @include mq($md) {
      cursor: pointer;
      display: none;
    }
  }

  &__logo {
    height: 4rem;
    display: flex;
    align-items: center;
    @include mq($md) {
      background-color: #000000;
    }
    img {
      display: none;
      @include mq($md) {
        display: block;
        height: 2rem;
        margin-left: 1rem;
      }
    }
  }

  &__option {
    height: 4rem;
    display: flex;
    align-items: center;
    padding-left: 1rem;
    border-left: 3px solid $b-blue;
    transition: all 0.2s ease-out;
    &:not(.md-button):hover{
      text-decoration: none;
    }
    & > div {
      display: flex;
      align-items: center;
    }
    @include mq($md) {
      cursor: pointer;
    }

    i {
      font-size: 2rem;
      line-height: 2rem;
      color: #7194bd;
    }
    span {
      color: white;
      margin-left: 1rem;
      text-transform: capitalize;
    }

    &.selected span {
      color: #000000;
    }
  }
}
</style>
